const CDN_BASE = process.env.NEXT_PUBLIC_CDN_URL || "";

/**
 * Convert a local image path to a CDN URL.
 * - Absolute URLs (http/https) pass through unchanged.
 * - Relative paths like "/images/posts/foo.png" get the CDN prefix.
 * - If no CDN_URL is configured, returns the path unchanged (local fallback).
 */
export function cdnUrl(path: string): string {
  if (!path) return path;
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  if (!CDN_BASE) return path;
  return `${CDN_BASE}${path.startsWith("/") ? path : `/${path}`}`;
}
